import { render, staticRenderFns } from "./ScriptCard.vue?vue&type=template&id=bfab6bb0&scoped=true&"
import script from "./ScriptCard.vue?vue&type=script&lang=ts&"
export * from "./ScriptCard.vue?vue&type=script&lang=ts&"
import style0 from "./ScriptCard.vue?vue&type=style&index=0&id=bfab6bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfab6bb0",
  null
  
)

export default component.exports